import { IGetMember, IGetMemberChild } from './../models/members.model';
import { AxiosError } from 'axios';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGetMembers, IMember, IMemberChild, IMemberList, IMemberParams } from "../models/members.model";
import { getMember, getMemberChildren, getMembers, updateMember } from '../api/members.api';

interface IMemberState {
  member?: IMember | undefined;
  members?: IMemberList[];
  memberChild?: IMemberChild[];
  isLoading: boolean;
  error?: AxiosError | string;
}

const initialState: IMemberState = {
  member: undefined,
  members: [],
  memberChild: [],
  isLoading: false,
}

const memberSlicer = createSlice({
  name: 'member',
  initialState,
  reducers: {
    getMemberStart: (state: IMemberState) => {
      state.member = undefined;
      state.isLoading = true;
      state.error = undefined;
    },
    getMemberSuccess: (state: IMemberState, action: PayloadAction<IGetMember>) => {
      state.member = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getMemberFailure: (state: IMemberState, action: PayloadAction<AxiosError | string>) => {
      state.member = undefined;
      state.isLoading = false;
      state.error = action.payload;
    },
    getMembersStart: (state: IMemberState) => {
      state.members = [];
      state.isLoading = true;
      state.error = undefined;
    },
    getMembersSuccess: (
      state: IMemberState,
      action: PayloadAction<IGetMembers>
    ) => {
      state.members = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getMembersFailure: (
      state: IMemberState,
      action: PayloadAction<AxiosError | string>,
    ) => {
      state.members = [];
      state.isLoading = false;
      state.error = action.payload;
    },
    getMemberChildStart: (state: IMemberState) => {
      state.memberChild = [];
      state.isLoading = true;
      state.error = undefined;
    },
    getMemberChildSuccess: (state: IMemberState, action: PayloadAction<IGetMemberChild>) => {
      state.memberChild = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getMemberChildFailure: (state: IMemberState, action: PayloadAction<AxiosError | string>) => {
      state.memberChild = [];
      state.isLoading = false;
      state.error = action.payload;
    },
    requestStart: (state: IMemberState) => {
      state.isLoading = true;
      state.error = undefined;
    },
    requestFailure: (
      state: IMemberState,
      action: PayloadAction<AxiosError | string>,
    ) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    updateSuccess: (state: IMemberState) => {
      state.isLoading = false;
      state.error = undefined;
    },
  },
});

export const {
  getMemberStart,
  getMemberSuccess,
  getMemberFailure,
  getMembersStart,
  getMembersSuccess,
  getMembersFailure,
  getMemberChildStart,
  getMemberChildSuccess,
  getMemberChildFailure,
  requestStart,
  requestFailure,
  updateSuccess,
} = memberSlicer.actions;

export default memberSlicer.reducer;

export const doGetMembers = (params?: IMemberParams): any => async (dispatch: any) => {
  try {
    dispatch(getMembersStart());
    const response = await getMembers(params);
    dispatch(getMembersSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getMembersFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

export const doGetMember = (memberCode: string): any => async (dispatch: any) => {
  try {
    dispatch(getMemberStart());
    const response = await getMember(memberCode);
    dispatch(getMemberSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getMemberFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

export const doUpdateMember = (memberCode: string, data: any): any => async (dispatch: any) => {
  try {
    dispatch(requestStart());
    const response = await updateMember(memberCode, data);
    dispatch(updateSuccess());
    return response;
  } catch (e: any) {
    dispatch(requestFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

export const doGetMemberChild = (memberCode: string): any => async (dispatch: any) => {
  try {
    dispatch(getMemberChildStart());
    const response = await getMemberChildren(memberCode);
    dispatch(getMemberChildSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getMemberChildFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};